import { useState, useCallback } from 'react';
import { SWIPE_CONSTANTS } from '@/constants/ActivitiesConfig.js';

export const useSwipeNavigation = ({ onNext, onPrev, currentIndex, totalImages, enabled = true }) => {
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    const onTouchStartHandler = useCallback(
        e => {
            if (!enabled) return;
            setTouchEnd(null);
            setTouchStart(e.targetTouches[0].clientX);
        },
        [enabled],
    );

    const onTouchMoveHandler = useCallback(
        e => {
            if (!enabled) return;
            setTouchEnd(e.targetTouches[0].clientX);
        },
        [enabled],
    );

    const onTouchEndHandler = useCallback(() => {
        if (!enabled || !touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > SWIPE_CONSTANTS.MIN_SWIPE_DISTANCE;
        const isRightSwipe = distance < -SWIPE_CONSTANTS.MIN_SWIPE_DISTANCE;

        if (isLeftSwipe && currentIndex < totalImages - 1) {
            onNext();
        }
        if (isRightSwipe && currentIndex > 0) {
            onPrev();
        }

        setTouchStart(null);
        setTouchEnd(null);
    }, [enabled, touchStart, touchEnd, currentIndex, totalImages, onNext, onPrev]);

    return {
        onTouchStart: onTouchStartHandler,
        onTouchMove: onTouchMoveHandler,
        onTouchEnd: onTouchEndHandler,
    };
};
